import api from '../../utils/api';
import {DictionaryItem, ParamsType, ServerMenu} from '../../utils';
import {ModuleMenu} from 'constants/menu';
import {BaseData, PageData} from 'utils/hooks/useNewPageData';

export class TableSchemaService {
    private version: number;

    public static getInstance(version?: number) {
        return new TableSchemaService(version);
    }

    private constructor(version?: number) {
        this.version = version || 1;
    }

    public getGeneralSchema() {
        return this.getSchema('/table/schema');
    }
    public getPageSchema(page: string, wellId?: string) {
        const wellIdParam = wellId ? `?wellId=${wellId}` : '';

        if (this.version === 2) {
            return this.getSchema(`/table/v2/${page}/table/schema${wellIdParam}`);
        }

        return wellId
            ? this.getSchema(`/table/supervising/schema/${page}${wellIdParam}`)
            : this.getSchema(`/table/schema/${page}`);
    }

    public getMenu(module: ModuleMenu): Promise<ServerMenu[]> {
        return this.getSchema(`/menus?module=${module}`);
    }

    private getSchema<Type>(url: string): Promise<Type> {
        return api.get<Type>(url);
    }

    public getDictionary({
        code,
        params,
    }: {
        code: string;
        params: ParamsType;
    }): Promise<DictionaryItem[]> {
        return api.get<DictionaryItem[]>(`/dict?code=${code}`, params);
    }

    public getEnumDictionary({
        code,
        params,
    }: {
        code: string;
        params: ParamsType;
    }): Promise<DictionaryItem[]> {
        return api.get<DictionaryItem[]>(`/dict/enum/${code}`, params);
    }

    public getProjectDictionary() {
        return api.get<DictionaryItem[]>('/wells/project');
    }

    public getContractDictionary() {
        return api.get<DictionaryItem[]>('/wells/contract');
    }

    public getGuiltySideDictionary() {
        return api.get<PageData<BaseData>>('/incidents/analyse/guilty-side/dict');
    }

    public getFilteredOptions({
        baseEntityId,
        entityName,
        fieldName,
    }: {
        baseEntityId: string;
        entityName: string;
        fieldName: string;
    }) {
        const baseEntityIdParam = baseEntityId ? `baseEntityId=${baseEntityId}&` : '';
        return api.get<{value: any; [key: string]: any}[]>(
            `/filter?${baseEntityIdParam}entityName=${entityName}&fieldName=${fieldName}`,
        );
    }
}
